import { useRef, useState } from 'react';
import { Trans } from 'react-i18next';
import { Swiper as SwiperType } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ReactComponent as NavItem } from '../../../assets/svg/NavItem.svg';
import { Banner } from '../../../services/content_v1';
import { useMediaQuery } from './TemporalBanner';

const SWIPER_DELAY = 5000;

interface WelcomeBannerItemProps {
    item: Banner,
}

export const WelcomeBannerItem = ({ item }: WelcomeBannerItemProps) => {
    const isMobile = useMediaQuery('(max-width: 600px)');

    return (
        <article className="welcome-promo__item" style={{ background: item.color || undefined }}>
            <div className="welcome-promo__item-body">
                <h2 className="welcome-promo__item-heading">{item.title}</h2>
                <ul className="welcome-promo__item-features">
                    {item.tags.map((tag) => <li key={tag}>{tag}</li>)}
                </ul>
                <p className="welcome-promo__item-cta">
                    <a href={item.url} className="btn" target={item.newtab ? '_blank' : undefined}>
                        <Trans>account:DETAILS</Trans>
                    </a>
                </p>
            </div>
            <div className="welcome-promo__item-image" style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', margin: isMobile ? undefined : '40px 40px 40px 0' }}>
                <img src={item.files?.at(0)} alt={item.files?.at(0)} style={{ maxWidth: isMobile ? '100%' : undefined }} />
            </div>
        </article>
    );
}

interface WelcomeBannersProps {
    banners: Banner[]
}

function WelcomeBanners({ banners }: WelcomeBannersProps) {
    // const [fetchBanners, { data: dataBanners }] = useLazyGetAllBannersQuery();
    const refPaginator = useRef<HTMLDivElement | null>(null);
    const refPaginatorPrev = useRef<HTMLDivElement | null>(null);
    const refPaginatorNext = useRef<HTMLDivElement | null>(null);
    const swiperRef = useRef<SwiperType | null>(null);

    const [stoppedSwipe, setStoppedSwipe] = useState(false);

    // useEffect(() => {
    //     fetchBanners();
    // }, []);
    return (banners.length || 0) > 0 && (
        <section className="welcome-promo">
            <Swiper
                modules={[Pagination, Navigation, Autoplay]}
                autoplay={{ delay: SWIPER_DELAY, disableOnInteraction: true }}
                loop
                onBeforeInit={(swiper) => {
                    swiperRef.current = swiper;
                }}
                // onSlideChange={() => console.log('slide change')}
                navigation={{
                    nextEl: refPaginatorNext.current,
                    prevEl: refPaginatorPrev.current,
                }}
                pagination={{
                    el: refPaginator.current,
                    clickable: true,
                    type: 'bullets',
                    bulletClass: 'welcome-promo__pagination-item',
                    bulletActiveClass: '_active',
                    renderBullet: function (index, className) {
                        return '<div class="' + className + '"><div class="welcome-promo__pagination-item-bar" style="animation-duration: ' + SWIPER_DELAY + 'ms;"></div></div>';
                    }
                }}
                onNavigationNext={() => console.log('Next')}
                onNavigationPrev={() => console.log('Prev')}
                onAutoplayStop={() => {
                    console.log('Swiper stopped');
                    setStoppedSwipe(true);
                }}
            >
                {banners.map((item) => <SwiperSlide key={item.id}>
                    <WelcomeBannerItem item={item} />
                </SwiperSlide>)}

                <div className="welcome-promo__nav">
                    <div ref={refPaginatorPrev} className="welcome-promo__nav-item _prev" onClick={() => swiperRef.current?.slidePrev()}>
                        <NavItem />
                    </div>
                    <div ref={refPaginatorNext} className="welcome-promo__nav-item _next" onClick={() => swiperRef.current?.slideNext()}>
                        <NavItem />
                    </div>
                </div>
            </Swiper>
            <div ref={refPaginator} className={`welcome-promo__pagination ${(stoppedSwipe ? '_normal' : '')}`} />
        </section>
    );
}

export default WelcomeBanners;
